import React, { useState } from 'react';
import { FaLock, FaUser } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import base_url from './config/Config';
import Cookies from 'js-cookie';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${base_url}/api/admin/loginDashboard`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        adminId: username,
        adminPassword: password
      })
    });

    if (response.ok) {
      const data = await response.json();
      localStorage.setItem('adminId', username); // Save adminId
      localStorage.setItem('password', password); // Save password
      Cookies.set('authToken', data.token, { expires: 1 }); // Save JWT token in cookie, expires in 1 day

      // Redirect to Dashboard on success
      navigate('/Dashboard');
    } else {
      // Handle login error
      alert('Login failed');
    }
  };

  return (
    <>
      <div className='backs login-page'>
        <div className='login-card-wrap'>
          <div className='login-card'>
            <div className='login-card-header'>
              <img src="../assets/images/logo.png" alt="Logo" height={55} />
              <h2 className='login-org-name'>UJJAWAL SRIJAN<br /><span>SOLUTION FOUNDATION</span></h2>
            </div>
            <form onSubmit={handleSubmit} className='login-form'>
              <div className='login-field'>
                <span className='login-field-icon'><FaUser /></span>
                <input
                  name='user_name'
                  id='user_name'
                  type="text"
                  placeholder='Username'
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className='login-field'>
                <span className='login-field-icon'><FaLock /></span>
                <input
                  type="password"
                  name="password"
                  id="password"
                  placeholder='Password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className='login-forgot'>
                <NavLink to="#">Forgot Password?</NavLink>
              </div>
              <button type="submit" className='login-submit-btn'>Login</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
